var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-popover",
    {
      attrs: { placement: _vm.placement, width: "200" },
      on: {
        show: function ($event) {
          _vm.warning = true
        },
      },
      model: {
        value: _vm.visible,
        callback: function ($$v) {
          _vm.visible = $$v
        },
        expression: "visible",
      },
    },
    [
      _vm.warning
        ? _c("div", [
            _c("h3", { staticStyle: { "text-align": "center" } }, [
              _vm._v("\n      Warning\n    "),
            ]),
            _vm._v(" "),
            _c(
              "div",
              {
                staticStyle: {
                  "word-break": "auto-phrase",
                  width: "180px",
                  "text-align": "center",
                  margin: "12px",
                },
              },
              [
                _vm._v(
                  "\n      Inform Neighbor that running a throughput test will pause device recordings, including 24/7 recording.\n      Functionality will resume once test is complete.\n    "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "text-align": "right", margin: "0" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "text" },
                    on: {
                      click: function ($event) {
                        _vm.visible = false
                      },
                    },
                  },
                  [_vm._v("\n        cancel\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.running,
                      type: "primary",
                      size: "mini",
                    },
                    on: {
                      click: function ($event) {
                        _vm.warning = false
                      },
                    },
                  },
                  [
                    _c("span", [
                      _c("i", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.running,
                            expression: "running",
                          },
                        ],
                        staticClass: "el-icon-loading",
                      }),
                      _vm._v("\n          continue\n        "),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ])
        : _c("div", [
            _c(
              "div",
              { staticStyle: { margin: "17px" } },
              _vm._l(_vm.throughput.test_settings, function (_, key) {
                return _c(
                  "el-checkbox",
                  {
                    key: key,
                    staticStyle: { display: "block", margin: "0" },
                    attrs: { disabled: "" },
                    on: {
                      change: function ($event) {
                        return _vm.switchSetting(key)
                      },
                    },
                    model: {
                      value: _vm.throughput.test_settings[key].bool,
                      callback: function ($$v) {
                        _vm.$set(_vm.throughput.test_settings[key], "bool", $$v)
                      },
                      expression: "throughput.test_settings[key].bool",
                    },
                  },
                  [
                    _vm._v(
                      "\n        " + _vm._s(_vm.startCase(key)) + "\n      "
                    ),
                  ]
                )
              }),
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticStyle: { "text-align": "right", margin: "0" } },
              [
                _c(
                  "el-button",
                  {
                    attrs: { size: "mini", type: "text" },
                    on: {
                      click: function ($event) {
                        _vm.visible = false
                      },
                    },
                  },
                  [_vm._v("\n        cancel\n      ")]
                ),
                _vm._v(" "),
                _c(
                  "el-button",
                  {
                    attrs: {
                      disabled: _vm.running,
                      type: "primary",
                      size: "mini",
                    },
                    on: { click: _vm.run },
                  },
                  [
                    _c("span", [
                      _c("i", {
                        directives: [
                          {
                            name: "show",
                            rawName: "v-show",
                            value: _vm.running,
                            expression: "running",
                          },
                        ],
                        staticClass: "el-icon-loading",
                      }),
                      _vm._v("\n          run\n        "),
                    ]),
                  ]
                ),
              ],
              1
            ),
          ]),
      _vm._v(" "),
      _c(
        "section",
        { attrs: { slot: "reference" }, slot: "reference" },
        [
          _vm._t("default", function () {
            return [
              _c("el-button", { attrs: { type: "text" } }, [
                _vm._v("\n        Throughput Test\n      "),
              ]),
            ]
          }),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }